import React, { useState } from "react";

export const TabHead = ({ headerData = [], openTab }) => {
  const [headerList, setHeaderList] = useState(headerData);

  const openNewTab = (tabId) => {
    let array = [...headerList];
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      element.active = false;
      if (element.id === tabId) {
        element.active = true;
      }
    }
    setHeaderList(array);
    openTab(tabId);
  };

  return (
    <div className="tabview_tabhead">
      {headerList.map((header) => {
        return (
          <div
            className={header.active ? "tabview_tabhead_item tabview_tabhead_item_active" : "tabview_tabhead_item"}
            key={header.id}
            onClick={() => {
              openNewTab(header.id);
            }}
          >
            {header.display}
          </div>
        );
      })}
    </div>
  );
};
